"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleUIOptimisationTableReview = exports.handleUIOptimisationTable = void 0;
var minScreenWidth = 336;
var screenPaddingHorizontal = 24;
var minRows = 3;
var handleUIOptimisationTable = function handleUIOptimisationTable() {
  var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var option = arguments.length > 1 ? arguments[1] : undefined;
  if (!html) {
    return html;
  }
  var isRichtext = (option === null || option === void 0 ? void 0 : option.isRichtext) || false;
  var resultContainer = document.createElement('div'); // 用于返回的 html

  resultContainer.innerHTML = html;
  var countContainer = document.createElement('div'); // 用于计算宽度的 html

  var clientWidth = document.documentElement.clientWidth - screenPaddingHorizontal;
  var richtextWidth = Math.max(clientWidth, minScreenWidth); // countContainer.style.width = `${richtextWidth}px`;
  //  让该 dom 渲染 但是不影响到页面

  countContainer.style.position = 'absolute';
  countContainer.style.left = '-9999px';
  countContainer.innerHTML = html;
  var tableCountContainerList = countContainer.querySelectorAll('div.quill-better-table-wrapper');
  tableCountContainerList.forEach(function (tableContainer) {
    var table = tableContainer.querySelector('table.quill-better-table');
    var colgroup = table === null || table === void 0 ? void 0 : table.querySelector('colgroup');
    if (table && colgroup) {
      table.removeChild(colgroup);
    }
    table === null || table === void 0 ? void 0 : table.setAttribute('style', 'width: auto');
  }); // 放入 body 然后获得渲染后 的 宽度

  document.body.appendChild(countContainer);
  var tableDataList = []; // 计算宽度

  tableCountContainerList.forEach(function (tableContainer) {
    var table = tableContainer.querySelector('table.quill-better-table');
    var tr = table === null || table === void 0 ? void 0 : table.querySelector('tr');
    if (tr) {
      var tdList = tr === null || tr === void 0 ? void 0 : tr.querySelectorAll('td');
      var list = [];
      var tdListLen = tdList === null || tdList === void 0 ? void 0 : tdList.length;
      var isTdLen3WithRIchtext = tdListLen <= 3 && isRichtext;
      if (tdListLen && (tdList === null || tdList === void 0 ? void 0 : tdList.length) >= minRows - 1) {
        var haveLongTd = false; // 是否有 超过 均分宽度的 td
        // 如果是 richtext 就按 80% 宽度

        var tdAverageWidth = (isTdLen3WithRIchtext ? richtextWidth * 0.8 : richtextWidth) / minRows;
        tdList.forEach(function (td) {
          var tdComputedStyle = window.getComputedStyle(td);
          var tdWidth = parseFloat(tdComputedStyle.width);
          if (tdWidth < tdAverageWidth) {
            list.push(tdWidth);
          } else {
            list.push(0);
            haveLongTd = true;
          }
        });
        if (!haveLongTd) {
          list = [];
        }
      }
      tableDataList.push(list);
    }
  }); // 获得 宽度后 设置在 返回的 html 里面

  var tableResultContainerList = resultContainer.querySelectorAll('div.quill-better-table-wrapper');
  tableResultContainerList.forEach(function (tableContainer, tableContainerIdx) {
    var table = tableContainer.querySelector('table.quill-better-table');
    var trList = table === null || table === void 0 ? void 0 : table.querySelectorAll('tr');
    var tableData = tableDataList[tableContainerIdx];
    var isTdLen3WithRIchtext = false;
    if (trList && table) {
      trList === null || trList === void 0 ? void 0 : trList.forEach(function (tr) {
        var tdList = tr === null || tr === void 0 ? void 0 : tr.querySelectorAll('td');
        isTdLen3WithRIchtext = (tdList === null || tdList === void 0 ? void 0 : tdList.length) <= 3 && isRichtext;
        if (tdList !== null && tdList !== void 0 && tdList.length) {
          tdList.forEach(function (td, tdIdx) {
            var tdWidth = tableData[tdIdx];
            if (td) {
              if (tdWidth) {
                td.style.width = "".concat(tdWidth, "px");
                td.style.flexShrink = '0';
              } else {
                td.style.flex = '1';
              }
            }
          });
        }
        var rowNum = Math.max(tdList === null || tdList === void 0 ? void 0 : tdList.length, minRows);
        tr.style.display = 'flex';
        tr.style.justifyContent = 'space-between';
        tr.style.width = isTdLen3WithRIchtext ? '100%' : "".concat(richtextWidth / minRows * rowNum, "px"); // table.setAttribute('style', `width: ${richtextWidth / 3 * tdList?.length}px!important;`);
      });
    }

    if (isTdLen3WithRIchtext) {
      var colgroup = table === null || table === void 0 ? void 0 : table.querySelector('colgroup');
      if (table && colgroup) {
        table.removeChild(colgroup);
      }
    }
  });
  document.body.removeChild(countContainer);
  return resultContainer.innerHTML;
};
exports.handleUIOptimisationTable = handleUIOptimisationTable;
var deleteIndex = 3;
var handleUIOptimisationTableReview = function handleUIOptimisationTableReview() {
  var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!html) {
    return html;
  }
  var container = document.createElement('div');
  container.innerHTML = html;
  var tableContainerList = container.querySelectorAll('div.quill-better-table-wrapper');
  tableContainerList.forEach(function (tableContainer) {
    var table = tableContainer.querySelector('table.quill-better-table');
    var trList = table === null || table === void 0 ? void 0 : table.querySelectorAll('tr');
    trList === null || trList === void 0 ? void 0 : trList.forEach(function (tr) {
      var tdList = tr === null || tr === void 0 ? void 0 : tr.querySelectorAll('td');
      tdList.forEach(function (td, tdIdx) {
        if (tdIdx >= deleteIndex) {
          tr.removeChild(td);
        }
      });
    });
    var colgroup = table === null || table === void 0 ? void 0 : table.querySelector('colgroup');
    var colList = colgroup === null || colgroup === void 0 ? void 0 : colgroup.querySelectorAll('col');
    colList === null || colList === void 0 ? void 0 : colList.forEach(function (col, colIdx) {
      if (colgroup && colIdx >= deleteIndex) {
        colgroup.removeChild(col);
      }
    });
  });
  return container.innerHTML;
};
exports.handleUIOptimisationTableReview = handleUIOptimisationTableReview;